<template>
  <div>
    <Title>需求清单</Title>
    <a-table bordered :data-source="list" :pagination="false">
      <a-table-column title="固定资产类型">
        <template slot-scope="text">
            <div style="display: flex;align-items: center">
              <DataDictFinder
              dictType="fixed_asset_type"
              :dictValue="text.category.categoryCode"
            />-
            {{text.category.subCategoryName}}
            </div>
          </template>
      </a-table-column>
        <a-table-column title="需求说明" data-index="desc"> </a-table-column>
        <a-table-column title="预计金额(元)" data-index="estimatedPrice"> </a-table-column>

        <a-table-column title="设备型号" align="center" v-if="detail.taskDefinitionKey == 'it_purchaser' || detail.taskDefinitionKey == 'arrival_confirmer' || detail.taskDefinitionKey == 'finance_confirmer'">
          <template slot-scope="text">
            <a-input v-model="text.brandModel" style="width: 150px" :disabled="detail.taskDefinitionKey !== 'it_purchaser'"/>
          </template>  
        </a-table-column>
        <a-table-column title="采购价格" align="center" v-if="detail.taskDefinitionKey == 'it_purchaser' || detail.taskDefinitionKey == 'arrival_confirmer' || detail.taskDefinitionKey == 'finance_confirmer'">
          <template slot-scope="text">
            <a-input-number v-model="text.purchasePrice" style="width: 100px" :disabled="detail.taskDefinitionKey !== 'it_purchaser'"/>
          </template>  
        </a-table-column>
        <a-table-column title="资产编码" data-index="assetCode"  v-if="detail.taskDefinitionKey == 'finance_confirmer'"> </a-table-column>
        <a-table-column title="财务编码" v-if="detail.taskDefinitionKey == 'finance_confirmer'">
          <template slot-scope="text">
            <a-input v-model="text.financialCode" style="width: 150px"/>
          </template>
        </a-table-column>
        <a-table-column title="启用日期" v-if="detail.taskDefinitionKey == 'finance_confirmer'">
          <template slot-scope="text">
            <a-date-picker
              style="width: 150px"
              format="YYYY-MM-DD"
              @change="(value) => { text.startTime = value.format('YYYY-MM-DD') }"
            />
          </template>
        </a-table-column>
        <a-table-column title="报废方式" data-index="category.scrapMethod" v-if="detail.taskDefinitionKey == 'arrival_confirmer'"> </a-table-column>
        <a-table-column title="报废时限(月)" data-index="category.scrapLimitMonths" v-if="detail.taskDefinitionKey == 'arrival_confirmer'"> </a-table-column>
        <a-table-column title="净残值率" data-index="category.netSalvageRate" v-if="detail.taskDefinitionKey == 'arrival_confirmer'"> </a-table-column>
    </a-table>
  </div>
</template>

<script>
import Title from "../Title";
import { mapState } from "vuex";
import request from "@/api/request";
function genCode(data) {
    return request({
    url: "/office-service/fixed-asset/gen-code",
    data,
    method: 'post'
  });
}
export default {
  components: {
    Title,
  },

  computed: {
    ...mapState("approval", ["detail"]),

    list() {
      return this.detail.extra?.fixedAssetList ?? [];
    },
  },
  mounted(){
    if(this.detail.taskDefinitionKey == 'arrival_confirmer'){
      this.list.forEach((row,index) => {
        genCode({
          categoryId: row.categoryId,
          startTime: row.startTime ? moment(row.startTime).format('YYYY-MM-DD') : '',
        }).then((res) => {
          console.log(this.detail.applicantId)
          this.list[index].assetCode = res;
          this.list[index].responsiblePersonName = this.detail.extra.applicant;
          this.list[index].responsiblePersonId = this.detail.extra.applicantId;
          this.list[index].deptId = this.detail.extra.applicantDeptId;
          this.list[index].deptName = this.detail.extra.applicantDeptName;
          this.list[index].status = 'fixed_asset_status_in_stock'
        });
      })
    }
  }
};
</script>